import {Grid, Typography} from "@mui/material";
import {useAppContext} from "@/contexts/AppContext.tsx";

export default function MainHeading({title, description, sx}: { title: string, description?: string, sx?: any }) {
    const {uiVisual} = useAppContext();

    return (
        <Grid container mb={3} sx={sx}>
            <Grid item md={6} xs={12}>
                <Typography fontSize={uiVisual === 'classic' ? 18 : 24} fontWeight={500}>
                    {title}
                </Typography>
                <Typography fontSize={14}>
                    {description}
                </Typography>
            </Grid>
        </Grid>
    )
}